export function getIsInFlowStep(stepId: string): boolean {
  return ['cruises', 'cabin-location'].includes(stepId)
}

export function getIsCabinRateStep(stepId: string): boolean {
  return stepId === 'cruises'
}

export function getCheckoutRouteFromURL(pathname: string): string {
  const split = pathname.split('/').pop() || ''
  return split?.split('?')[0]
}
